const router = require("services/router");

function videoModal(parentContainer = document, className = "videoModal") {

	let play = document.getElementsByClassName("play-btn");
	let content = document.getElementsByClassName('video-modal-content');

	if (typeof(play[0]) == 'undefined' || play[0] == null) {
	    return;
	}

	play[0].addEventListener("click", () => {

		const videoUrl = play[0].getAttribute('data-url');
		const videoId = getId(videoUrl);

	    openModal(videoId);
	});

	function getId(url) {
	    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	    var match = url.match(regExp);

	    if (match && match[2].length == 11) {
	        return match[2];
	    } else {
	        return 'error';
	    }
	}

	function openModal(videoId){
		document.body.className += ' open-video';

		// content[0].innerHTML += '<iframe width="560" height="315" src="//www.youtube.com/embed/' + videoId + '?autoplay=1" frameborder="0" allowfullscreen></iframe>';
		content[0].innerHTML += '<video controls autoplay controlsList="nodownload"><source src="'+router.url("video/clevermate.mp4")+'" type="video/mp4">Your browser does not support HTML5 video.</video>';

	}

	document.getElementsByClassName("video-overlay")[0].addEventListener("click", () => {
	    closeModal();
	});
	document.addEventListener('keydown', (e) => {
		const keyName = e.key;
		if(keyName == 'Escape'){
			closeModal();
		}
	});
	function closeModal(){
		document.body.className += ' close-video';

		setTimeout(function(){
			document.body.className = document.body.className.replace(/\bopen-video\b/g, "");
			content[0].innerHTML = '';
		}, 500);

		let width = window.innerWidth;

		if (width < 980) {

			setTimeout(function(){
				document.body.className = document.body.className.replace(/\bclose-video\b/g, "");
			}, 1000);

		}else {
			setTimeout(function(){
				document.body.className = document.body.className.replace(/\bclose-video\b/g, "");
			}, 700);
		}
	}
}

module.exports = videoModal;


// WEBPACK FOOTER //
// ./resources/js/modules/video-modal.js